import React, {Fragment} from 'react';
import {
    Card,
    Table,
    Menu,
    Dropdown,
    Space,
    Input,
    Row,
    Button,
    Typography,
    Modal,
    Form,
    Select,
    Checkbox,
    TimePicker,
    InputNumber,
    notification,
    Spin, Steps, Divider, DatePicker, Switch
} from "antd";

import {
    DownOutlined,
    DownloadOutlined,
    DeleteOutlined,
    PlusOutlined,
    EuroCircleOutlined,
    LinkOutlined,
    MinusOutlined
} from '@ant-design/icons';

import ApiService from "../../../services/ApiService"

import moment from 'moment'

import MultiAssocForm2 from "../../../components/custom-fields/MultiAssocForm2";
import PermissionAlert from "../../../components/permissions/PermissionAlert";

import { t } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";

const {Search} = Input;
const {Text} = Typography;
const {Option} = Select;


export default class ModalChangeOrigin extends React.Component {

    constructor(props) {
        super(props);
        props.getRef(this)
    }

    initstate = {
        visible: false,
        loading: false,
        info: null,
        types: [],
        type: null,
        step: 1,
        contacts: [],
        contact: null,
        service: {},
        id: null
    };

    state = this.initstate

    async show(id, contact = null, type = "GENERAL", typeId = null, service = {}) {
        console.log("PAYEMENT CHANGE ORIGIN ")

        this.setState({
            visible: true,
            id: id,
            contact: contact,
            type: {value: typeId, type: type},
            service: service
        }, () => {
            this.getContacts()
            this.getTypes()
        })
    }

    async getTypes(callback = null) {
        var res2 = await ApiService.get("/paiements/cerfa/types/", {contact: this.state.contact})
        console.log(res2)
        this.setState({types: res2.items}, () => {
            if (callback) {
                callback()
            }
        })
    }

    async getContacts() {
        var res = await ApiService.get("/contact/form")
        this.setState({contacts: res.data})
    }

    close() {
        this.setState(this.initstate)
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevState.contact != this.state.contact && this.state.contact) {
            this.getTypes()
        }
    }

    async onFinish(data) {
        console.log(data)

        if (!this.state.type) {
            return false
        }

        var type = this.state.type

        var config = {
            type: type.type,
            typeId: type.value,
            service: null
        }

        var res = await ApiService.post("/paiements/change/origin/" + this.state.id, config)
        console.log(res)

        if (res.success) {
            notification.success({
                message: t`Modification réussie`
            })

            this.close()
            if (this.props.onFinish) {
                this.props.onFinish()
            }
        } else {
            notification.error({
                message: t`Erreur lors de la modification`
            })
        }
    }


    render() {
        return (
            <Fragment>
                <Modal
                    width={"100%"}
                    style={{minHeight: 500}}
                    title={t`Modifier la raison du paiement`}
                    open={this.state.visible}
                    destroyOnClose
                    closable
                    footer={null}
                    onCancel={() => this.close()}
                >
                    <PermissionAlert permissions={["paiement.edit"]}>
                        {/*
                        <Steps current={this.state.step} status={this.state.loading?"wait":"process"}>
                            <Steps.Step title={t`Informations`} description={this.state.info?this.state.info.nom+" "+this.state.info.prenom:null} />
                            <Steps.Step title={t`Raison`} description={this.state.type?this.state.type.label:null} />
                            <Steps.Step title={t`Paiement`} description="" />
                        </Steps>
                        */}

                        {this.state.step == 1 && (
                            <Form
                                initialValues={{
                                    raison: this.state.type?.value,
                                }}
                                onFinish={(data) => this.onFinish(data)}
                            >
                                <div style={{
                                    margin: "50px 0px",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center"
                                }}>
                                    <Form.Item
                                        label={t`Raison du Paiement`}
                                        name="raison"
                                    >
                                        <Select
                                            style={{width: 500, maxWidth: "100%"}}
                                            placeholder={t`Raison du Paiement`}
                                            onChange={(value) => {
                                                const item = this.state.types.find(i => i.value == value)
                                                this.setState({type: item})
                                            }}
                                        >
                                            {this.state.types.map((item, index) => {
                                                return <Option key={index} value={item.value}>{item.label}</Option>
                                            })}
                                        </Select>
                                    </Form.Item>
                                </div>

                                <Form.Item style={{display: "flex", justifyContent: "flex-end"}}>
                                    <Button
                                        type="primary"
                                        htmlType="submit"
                                        loading={this.state.loading}
                                    >
                                        <Trans>Valider</Trans>
                                    </Button>
                                </Form.Item>
                            </Form>
                        )}
                    </PermissionAlert>
                </Modal>
            </Fragment>
        )
    }
}
